export default "__VITE_ASSET__69a37581__"